import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Button from "../../../../component/button/Button";
import Input from "../../../../component/input/Input";
import Select from "../../../../component/multiSelect/MultiSelect";
import useClientConfig from "../../../../config/careers/clientConfig";

const OptionFiveJobFilter = (props: any) => {
    const location = useLocation();
    const routeParams = useParams();
    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const langLabels = cliendConfig?.data?.data?.clientSettings?.languageSettings;
    const searchLangLabels = langLabels?.searchSection?.[0];
    const { clientSiteSettings } = useClientConfig();

    const {
        filter,
        checkListControl,
        tableControl,
        searchControlSubmit,
        setTableControl,
        removeSearchForm,
    } = props;

    return (
        <section className={`option5-filter-shell ${location.pathname === `/view/${routeParams?.id}` ? "is-job-view" : ""}`}>
            <div className="option5-filter-head">
                <h2>{searchLangLabels?.searchJobs || "Search Jobs"}</h2>
                {location.pathname !== `/view/${routeParams?.id}` && checkListControl ? (
                    <Button
                        onClick={() => removeSearchForm()}
                        clasName="btn option5-clear-btn"
                        icon={"pi pi-times"}
                        position="left"
                        label={"Clear Filters"}
                    />
                ) : (
                    ""
                )}
            </div>

            <div className="option5-filter-grid">
                <div className="option5-field option5-field-wide">
                    <label>{searchLangLabels?.search || "Search"}</label>
                    <Input
                        className="form-control option5-input"
                        type={"text"}
                        value={tableControl.searchText}
                        placeholder={clientSiteSettings?.templateName === "template_10" ? "Search by Job Title, Keywords.." : `${searchLangLabels?.searchPlaceholder || "Search"}...`}
                        name={searchLangLabels?.search}
                        onChange={(e: { target: { value: any } }) => {
                            setTableControl((prs: any) => ({
                                ...prs,
                                searchText: e.target.value
                            }));
                        }}
                    />
                </div>

                {filter.jobCategories ? (
                    <div className="option5-field">
                        <label>{searchLangLabels?.category || "Category"}</label>
                        <Select
                            isSearchable={true}
                            className="joblist-multi-select option5-select"
                            placeholder={searchLangLabels?.all}
                            isMulti={true}
                            onChange={(e: any) => {
                                setTableControl((prs: any) => ({
                                    ...prs,
                                    searchCat: e
                                }));
                            }}
                            value={tableControl.searchCat}
                            options={filter.jobCategories}
                        />
                    </div>
                ) : (
                    ""
                )}

                {filter.jobTypes ? (
                    <div className="option5-field">
                        <label>{searchLangLabels?.jobTypes || "Job type"}</label>
                        <Select
                            isSearchable={true}
                            className="joblist-multi-select option5-select"
                            placeholder={searchLangLabels?.all}
                            isMulti={true}
                            onChange={(e: any) => {
                                setTableControl((prs: any) => ({
                                    ...prs,
                                    searchJob: e
                                }));
                            }}
                            value={tableControl.searchJob}
                            options={filter.jobTypes}
                        />
                    </div>
                ) : (
                    ""
                )}

                {filter.jobLocations ? (
                    <div className="option5-field">
                        <label>{searchLangLabels?.locations || "Location"}</label>
                        <Select
                            isSearchable={true}
                            className="joblist-multi-select option5-select"
                            placeholder={searchLangLabels?.all}
                            isMulti={true}
                            onChange={(e: any) => {
                                setTableControl((prs: any) => ({
                                    ...prs,
                                    searchLocation: e
                                }));
                            }}
                            value={tableControl.searchLocation}
                            options={filter.jobLocations}
                        />
                    </div>
                ) : (
                    ""
                )}
            </div>

            <div className="option5-filter-actions">
                <Button
                    clasName="btn option5-search-btn"
                    label={searchLangLabels?.search || "Search"}
                    position="left"
                    icon="pi pi-search"
                    onClick={() => searchControlSubmit()}
                />
            </div>
        </section>
    );
};

export default OptionFiveJobFilter;
